import { resolveModuleType } from "../config/moduleTypes";

const FALLBACK_COLOR = "#888888 ";

export function getModuleTypeColor(moduleType) {
  return resolveModuleType(moduleType)?.color ?? FALLBACK_COLOR;
}

// moduleThumbnails() used to live here — it's about module *instances* (ABCDE, NEWS2, ...), a
// different concern from module *types*. Moved to its own file, ../config/moduleThumbnails.js
// (MODULE_THUMBNAILS / MODULE_THUMBNAIL_LIST / getModuleThumbnail), and both call sites updated
// to import from there directly.

/**
 * Names as they was when they bought the packages, such as VR Safe, VR Obs etc.
 * @param moduleType
 * @returns {string}
 */
export function modulePackageName(moduleType) {
  if (moduleType === undefined) {
    return "";
  }
  return resolveModuleType(moduleType)?.packageName ?? `Undefined: '${moduleType}'`;
}

/**
 * Names such as Mental Helse, Fysisk Helse, Førstehjelp etc.
 * @param moduleType
 * @returns {string}
 */
export function moduleCategoryName(moduleType) {
  if (moduleType === undefined) {
    return "";
  }
  return resolveModuleType(moduleType)?.categoryName ?? `Undefined: '${moduleType}'`;
}
